/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountInfos.defs'
export { main as default } from './getAccountInfos.defs'
